import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgChatgptRegularAiIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 32 32",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M10.1 10a5 5 0 0 1 3.5 1.5l1.6-.3a5 5 0 0 1 4.8 6.3 5 5 0 0 1 1.7 3.7 5 5 0 0 1-3.7 4.9 5 5 0 0 1-4.9 4 5 5 0 0 1-3.5-1.5l-1.5.3a5 5 0 0 1-4.9-6.3A5 5 0 0 1 1.5 19a5 5 0 0 1 3.7-5 5 5 0 0 1 5-4m5 15-.4.7-4 2.3q1 .8 2.3.8c2.3 0 4-1.7 4-3.8v-4.4q0-.3-.3-.4l-1.6-1zm-6.2.6h-.8l-3.9-2.3v.5c0 2 1.6 3.8 3.9 3.8q.9 0 1.8-.5l3.8-2.2.2-.3v-2zm5.9-10h-.4l-1.7 1 5 2.9q.4.1.4.6v4.5c1.4-.5 2.3-2 2.3-3.5a4 4 0 0 0-1.8-3.3zM5 15.4a4 4 0 0 0-2.4 3.5 4 4 0 0 0 1.9 3.3l3.8 2.2h.4l1.6-1-5-2.8-.3-.7zm4.2 3.3v2.8l2.3 1.3 2.4-1.3v-2.8l-2.4-1.4zm.8-7.4A3.7 3.7 0 0 0 6.3 15v4.4q0 .3.2.4l1.6 1v-5.9q0-.3.4-.6l3.9-2.3q-1-.7-2.3-.7m5 1.1q-1 0-1.8.5L9.5 15q-.2 0-.2.3v2l5-3h.7l4 2.3v-.4c0-2-1.5-3.9-4-3.9M25 2q.4 0 .6.5v.1l.3 1.4q.4 1.3 1 2.2.8.7 2.2 1l1.4.3a.6.6 0 0 1 0 1.2L29 9q-1.4.4-2.2 1-.7.9-1 2.2l-.3 1.4v.1a.6.6 0 0 1-1.3 0v-.4l-.3-1q-.4-1.5-1-2.2-.9-.9-2.2-1l-1.4-.4a.6.6 0 0 1 0-1.2h.4l1-.3q1.4-.4 2.2-1c.8-.6.8-1.4 1-2.2l.3-1.4A1 1 0 0 1 25 2"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "url(#openaiOutlineAiGradient)",
			d: "M10.1 10a5 5 0 0 1 3.5 1.5l1.6-.3a5 5 0 0 1 4.8 6.3 5 5 0 0 1 1.7 3.7 5 5 0 0 1-3.7 4.9 5 5 0 0 1-4.9 4 5 5 0 0 1-3.5-1.5l-1.5.3a5 5 0 0 1-4.9-6.3A5 5 0 0 1 1.5 19a5 5 0 0 1 3.7-5 5 5 0 0 1 5-4m5 15-.4.7-4 2.3q1 .8 2.3.8c2.3 0 4-1.7 4-3.8v-4.4q0-.3-.3-.4l-1.6-1zm-6.2.6h-.8l-3.9-2.3v.5c0 2 1.6 3.8 3.9 3.8q.9 0 1.8-.5l3.8-2.2.2-.3v-2zm5.9-10h-.4l-1.7 1 5 2.9q.4.1.4.6v4.5c1.4-.5 2.3-2 2.3-3.5a4 4 0 0 0-1.8-3.3zM5 15.4a4 4 0 0 0-2.4 3.5 4 4 0 0 0 1.9 3.3l3.8 2.2h.4l1.6-1-5-2.8-.3-.7zm4.2 3.3v2.8l2.3 1.3 2.4-1.3v-2.8l-2.4-1.4zm.8-7.4A3.7 3.7 0 0 0 6.3 15v4.4q0 .3.2.4l1.6 1v-5.9q0-.3.4-.6l3.9-2.3q-1-.7-2.3-.7m5 1.1q-1 0-1.8.5L9.5 15q-.2 0-.2.3v2l5-3h.7l4 2.3v-.4c0-2-1.5-3.9-4-3.9M25 2q.4 0 .6.5v.1l.3 1.4q.4 1.3 1 2.2.8.7 2.2 1l1.4.3a.6.6 0 0 1 0 1.2L29 9q-1.4.4-2.2 1-.7.9-1 2.2l-.3 1.4v.1a.6.6 0 0 1-1.3 0v-.4l-.3-1q-.4-1.5-1-2.2-.9-.9-2.2-1l-1.4-.4a.6.6 0 0 1 0-1.2h.4l1-.3q1.4-.4 2.2-1c.8-.6.8-1.4 1-2.2l.3-1.4A1 1 0 0 1 25 2"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
			id: "openaiOutlineAiGradient",
			x1: 31.41,
			x2: -1.63,
			y1: 2,
			y2: 37.89,
			gradientUnits: "userSpaceOnUse",
			children: [
				/* @__PURE__ */ _jsx("stop", { stopColor: "#e2a9ff" }),
				/* @__PURE__ */ _jsx("stop", {
					offset: .34,
					stopColor: "#bb97f6"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .65,
					stopColor: "#8b5cf6"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#602bcc"
				})
			]
		}) })
	]
});
export default SvgChatgptRegularAiIcon;
